import React, { Component, ReactNode } from 'react';
import { ErrorBoundaryContext } from './ErrorBoundaryContext';

interface ErrorBoundaryProps {
  children: ReactNode;
  errorContent: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static contextType = ErrorBoundaryContext;

  context!: React.ContextType<typeof ErrorBoundaryContext>;

  state: ErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    this.context.handleError(error);
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children, errorContent } = this.props;
    return hasError ? errorContent : children;
  }
}

export default ErrorBoundary;

export { ErrorBoundaryProvider } from './ErrorBoundaryContext';
